<template>
  <div>
    <Frontendlayout>
      <section class="hero_in tours">
        <div class="wrapper">
          <div class="container">
            <h1 class="fadeInUp"><span></span>Requirement List</h1>
          </div>
        </div>
      </section>
      <!--/hero_in-->
      <div class="bg_color_1">
        <div class="container-fluid">
          <div class="row">
            <Sidebar />

            <div class="col-lg-10">
              <div class="box_general">
                <!-- <div class="header_box">
                  <h5 class="d-inline-block text-center">
                    List Of Requirement
                  </h5>
                </div> -->
                <div class="list_general">
                  <form @submit.prevent="searchRequirement()" method="post">
                    <div class="row">
                      <div class="col-md-3">
                        <div class="form-group">
                          <label for="category">Status</label>
                          <select
                            name=""
                            class="form-control"
                            id="category"
                            v-model="search.status"
                          >
                            <option value="1" :selected="true">Active</option>
                            <option value="2">Inactive</option>
                          </select>
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="form-group">
                          <label for="category">Occasion</label>
                          <select
                            name=""
                            class="form-control select2"
                            id="category"
                            v-model="search.event"
                          >
                            <option value="">-Select-</option>
                            <option value="birthday">BirthDay</option>
                            <option value="anniversary">Anniversary</option>
                            <option value="party">Party</option>
                            <option value="engagement">Engagement</option>
                            <option value="baby-shower">Baby-shower</option>
                            <option value="farewell">Farewell</option>
                            <option value="retirement">Retirement</option>
                            <option value="others">Others</option>
                          </select>
                        </div>
                      </div>
                      <div class="col-lg-3">
                        <label>Location</label>
                        <vue-simple-suggest
                            v-model="search.location"
                            display-attribute="name"
                            value-attribute="url"
                            :list="getSuggestionList"
                          ></vue-simple-suggest>
                          <a href="javascript:void(0);" @click="currentLoc()"
                           >Use My Current Location</a
                             >
                      </div>
                      <div class="col-lg-3">
                        <label>Pincode</label>
                        <input
                          class="form-control"
                          type="number"
                          v-model="search.pincode"
                        />
                      </div>
                      <div class="col-lg-5">
                        <label>Categories</label>
                        <select2-multiple-control
                          :options="catOptions"
                          :settings="{
                            multiple: true,
                          }"
                          multiple
                          @select="catSelectEvent($event)"
                        />
                      </div>

                      <div class="col-lg-5">
                        <label>Sub Categories</label>
                        <select2-multiple-control
                          :options="subCatOptions"
                          :settings="{ multiple: true }"
                          @select="subcatselectEvent($event)"
                          placeholder="-Select Categories-"
                        />
                      </div>
                      <div class="col-md-2">
                        <center>
                          <button type="submit" class="btn_1 add_top_30 mb-4">
                            Search
                          </button>
                        </center>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
              <div class="row">
                <div class="col mb-3">
                  <router-link
                    class="btn btn-success pull-right"
                    to="/post-requirement"
                    aria-expanded="false"
                  >
                    <i class="fa fa-plus"></i>
                    <span class="nav-link-text">New Requirement</span>
                  </router-link>
                </div>
              </div>
              <table
                class="table table-striped table-bordered table-sm"
                cellspacing="0"
                width="100%"
                id="table"
              >
                <thead>
                  <tr>
                    <th scope="col">Sno</th>
                    <th scope="col">Categories</th>
                    <th scope="col">Event Date</th>
                    <th scope="col">Expire Date</th>
                    <th scope="col">Location</th>
                    <th scope="col">Pincode</th>
                    <th scope="col">Short Description</th>
                    <th scope="col">Occasion</th>
                    <th scope="col">Status</th>
                    <th scope="col">Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(journey, index) in journeyList" :key="journey.id">
                    <td>{{ index + 1 }}</td>
                    <td>
                      <!-- <b>Offers to be suggested in:</b> -->
                      <span v-for="cat in journey.categories" :key="cat.id">
                        {{ cat.category }},</span
                      >
                    </td>
                    <td>{{ frontEndDateFormat(journey.event_date) }}</td>
                    <td>{{ frontEndDateFormat(journey.event_end) }}</td>
                    <td>{{ journey.location }}</td>
                    <td>{{ journey.pincode }}</td>
                    <td>{{ journey.short_description }}</td>
                    <td>{{ journey.event }}</td>
                    <td>{{ journey.status == 2 ? "Inactive" : "Active" }}</td>
                    <td style="padding: 30px 0px">
                      <small
                        ><br /><i>
                          <a
                            href="#"
                            @click="redirect(journey.id, 'Update-rquirement')"
                            title="Edit Journey"
                            ><i class="fa fa-edit ml-3"></i>Update</a
                          ></i
                        ></small
                      >

                      <a
                        href="#"
                        class="ml-3"
                        @click="deletereq(journey.id)"
                        title="Edit Journey"
                        ><span class="badge badge-info"
                          ><i class="fa fa-trash"></i> Delete<br /> </span></a
                      ><small
                        ><br /><i>
                          <router-link
                            :to="`/user-post-single/${journey.id}/#reviews`"
                            class="ml-3"
                          >
                            Offers</router-link
                          ></i
                        ></small
                      >
                      <!--a href="#"><i class="fa fa-trash"></i></a-->
                    </td>
                  </tr>
                </tbody>
              </table>

              <!-- /cart-options -->
            </div>
            <!-- /col -->
          </div>
          <!-- /row -->
        </div>
        <!-- /container -->
      </div>

      <!-- /bg_color_1 -->
    </Frontendlayout>
  </div>
</template>

<script>
// import axios from 'axios'
// import Alert from "../cmps/Alert";
import API from "../services/index";
import moment from "moment";
import jQuery from "jquery";  

import Frontendlayout from "@/layouts/Frontendlayout.vue";
import Sidebar from "@/layouts/Sidebar.vue";
import "jquery/dist/jquery.min.js";
import "datatables.net-dt/js/dataTables.dataTables"
import "datatables.net-dt/css/jquery.dataTables.min.css"
import "datatables.net-buttons/js/dataTables.buttons.js"
import "datatables.net-buttons/js/buttons.colVis.js"
import "datatables.net-buttons/js/buttons.flash.js"
import "datatables.net-buttons/js/buttons.html5.js"
import "datatables.net-buttons/js/buttons.print.js"
import VueSimpleSuggest from "vue-simple-suggest";
import "vue-simple-suggest/dist/styles.css";
export default {
  data() {
    return {
      search: {
        pincode: "",
        location: "",
        event: "",
        status: "1",
      },
      journeyList: [],
      msg: null,
      roleId: localStorage.getItem("role_id"),
      event: "",
      pincode: "",
      location: "",
      searchcat: {
        categories: [],
        subcategories: [],
      },
      category_id: [],
      catOptions: [],
      subCatOptions: [],
      offers: [],
      dt: "",
    };
  },

  beforeMount() {
    this.getjourneyList(), this.checkToken();
    this.getParentCategories();
    this.getAreaofinterest();
  },

  methods: {
    frontEndDateFormat(date) {
      //alert(date);
      return moment(date).format("DD/MM/YYYY hh:mm");
    },
    getAreaofinterest() {
      const token = "Bearer " + localStorage.getItem("token");
      // alert(token);

      API.get("customer/category_by_customerId", {
        headers: { Authorization: token },
      })
        .then((res) => {
          this.categories = res.data.data;
          // res.data.data.forEach((value) => {
          //   // this.category_id.push(value.tag_id);
          // });
        })
        .catch((err) => {
          console.log(err.response);
        });
    },
    currentLoc() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(this.showPosition)
      } else {
        this.error = 'Geolocation is not supported.'
      }
    },
   showPosition(position){
  position.coords.latitude
  position.coords.longitude
  var location = [position.coords.latitude,position.coords.longitude]
  this.SuggestionList(location)
      
   }, 
 getSuggestionList() {
      var i = [];
      // if (this.search.location.length >= 2) {
        return API.get(
          `https://location.securebrandtech.com/auto/api?q=${this.search.location}`
        )
          .then( (response)=> {
            response.data.features.forEach(function (feature) {
              i.push(
                feature.properties.name +
                  " " +
                  feature.properties.county +
                  " " +
                  " " +
                  feature.properties.state +
                  " " +
                  feature.properties.postcode
              );
            });
            var uniq = [...new Set(i)];
 
            return uniq;
          
          })

          .catch(function (error) {
            console.log(error);
          });
      // }
 },
 SuggestionList(location){
      var i = [];
      // if (this.search.location.length >= 2) {
         API.get(`https://location.securebrandtech.com/auto/api?q=india&lat=${location[0]}&lon=${location[1]}`
        )
          .then( (response)=> {
            response.data.features.forEach(function (feature) {
              i.push(
                feature.properties.name +
                  " " +
                  feature.properties.county?feature.properties.county:"" +
                  " " +
                  " " +
                  feature.properties.state?feature.properties.state:"" +
                  " " +
                  feature.properties.postcode?feature.properties.postcode:""
              );
            });
            var uniq = [...new Set(i)];
            this.search.location = uniq[1]        
          })

          .catch(function (error) {
            console.log(error);
          });
 },
    searchRequirement() {
      const token = "Bearer " + localStorage.getItem("token");

      const form = new FormData();
      form.append("search", JSON.stringify(this.search));
      form.append("categories", JSON.stringify(this.searchcat.categories));
      form.append(
        "subcategories",
        JSON.stringify(this.searchcat.subcategories)
      );
      API.post(`/Postrequirement/search/roll`, form, {
        headers: { Authorization: token },
      })
        .then((res) => {
          if (res.data.status == 200) {
            // this.dt=null;

            // this.msg = "Your Profile updated Successfully";
            // this.classAlert = "success";
            // this.$router.push({ name: 'UserPost' })
            // this.journeyList = res.data.data
            // this.msg=''
            this.dt = jQuery("#table").DataTable();

            setTimeout(() => (this.journeyList = res.data.data));
          } else {
            this.dt = jQuery("#table").DataTable();
            this.journeyList = res.data.data;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getParentCategories() {
      API.get("categories/parent_services_select2list")
        //.get("categories/parent_services")
        .then((res) => {
          this.catOptions = res.data.data;

          // this.search = this.search.categories;
          console.log(res.data.data);
        })
        .catch((err) => {
          console.log(err.response);
        });
    },
    setSubCategory(categoryId, mode) {
      //alert(categoryId);
      // let selSubCat = this.search.subcategories;
      API.get(
        "categories/parent_services_select2list/" + window.btoa(categoryId)
      )
        //.get("categories/parent_services")
        .then((res) => {
          if (mode == "push") {
            res.data.data.forEach((val) => {
              console.log("val=" + JSON.stringify(val));
              this.subCatOptions.push(val);
              //this.subCatOptions.concat(res.data.data);
            });

            //console.log("sub cat options=" + this.subCatOptions);
          } else {
            //this.search.subcategories.push(res.data.data);
            res.data.data.forEach((val) => {
              this.subCatOptions.splice(this.subCatOptions.indexOf(val.id), 1);
            });
          }
          this.searchcat.subcategories = [];
          // this.emitFilterRequest();
          //this.loadNearbyOffers(this.search);
        })
        .catch((err) => {
          console.log(err.response);
        });
    },
    catSelectEvent(e) {
      var sel = e.selected;
      if (sel) {
        this.setSubCategory(e.id, "push");
        this.searchcat.categories.push(e.id);
      } else {
        this.setSubCategory(e.id, "remove");
        this.searchcat.categories.splice(
          this.searchcat.categories.indexOf(e.id),
          1
        );
      }
    },
    subcatselectEvent(e) {
      var sel = e.selected;
      //alert(sel + " " + e.id + " " + e.text + " " + e.selected);
      if (sel) {
        this.searchcat.subcategories.push(e.id);
      }

      //this.loadNearbyOffers(this.search);
    },

    redirect(offerid, url) {
      //alert(offerid + " " + url);
      this.$router.push(url + "/" + window.btoa(offerid));
    },
    moment: function () {
      return moment();
    },

    getjourneyList() {
      const token = "Bearer " + localStorage.getItem("token");
      // alert(id);
      API.get("Postrequirement/singleList", {
        headers: { Authorization: token },
      })
        .then((res) => {
          this.dt = jQuery("#table").DataTable(
          );
          this.journeyList = res.data.data;

          //  setTimeout(() => (this.journeyList = res.data.data));
          //  jQuery(".dataTables_empty").empty();
          //  jQuery(".dataTables_empty").hide();

          // setTimeout(() => (this.journeyList = res.data.data));
        })

        .catch((err) => {
          console.log(err.response);
        });
      // jQuery('.odd').hide()
    },
    deletereq(id) {
      const token = "Bearer " + localStorage.getItem("token");
      // alert(id);
      API.get(`Postrequirement/deletereq/${id}`, {
        headers: { Authorization: token },
      })
        .then((res) => {
          if (res.data.status == 200) {
            this.getjourneyList();
          }
        })
        .catch((err) => {
          console.log(err.response);
        });
    },
    checkToken() {
      const token = localStorage.getItem("token");
      // alert(token);
      if (token == null) {
        this.$router.push("/signin");
      }
    },
  },
  components: {
    Frontendlayout,
    Sidebar,
    VueSimpleSuggest,
  },
  watch: {
    journeyList(val) {
      this.dt.destroy();

      this.$nextTick(() => {
        if (val.length > 0) {
          console.log(val);
        } else {
          this.dt = jQuery("#table").DataTable({
                processing: true,
                dom: 'Bfrtip',
                    buttons: ['copy', 'csv', 'print'
                    ]
          });
        }
        //this.ShowList();
      });
    },
  },
};
</script>
<style  scoped>
@import "../../public/frontend/vendor/dropzone.css";

.journey {
  padding: 30px;
  background: #fff;
}
.fa {
  padding: 0 5px;
}
.odd {
  display: none !important;
}
@media (max-width: 991px) {
  .table.cart-list td:nth-of-type(1):before,
  .table.cart-list td:nth-of-type(2):before,
  .table.cart-list td:nth-of-type(3):before,
  .table.cart-list td:nth-of-type(4):before,
  .table.cart-list td:nth-of-type(5):before,
  .table.cart-list td:nth-of-type(6):before {
    font-weight: 600;
    color: #111;
  }

  .table.cart-list td:nth-of-type(1):before {
    content: "Journey Name";
  }
  .table.cart-list td:nth-of-type(2):before {
    content: "Start Date";
  }

  .table.cart-list td:nth-of-type(3):before {
    content: "End Date";
  }

  .table.cart-list td:nth-of-type(4):before {
    content: "Travelling From";
  }

  .table.cart-list td:nth-of-type(5):before {
    content: "Travelling To";
  }

  .table.cart-list td:nth-of-type(6):before {
    content: "Journey type";
  }

  .table.cart-list td:nth-of-type(7):before {
    content: "Actions";
  }
}
</style>